//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const UserMigrationBackgroundTimeout: FeatureFlag = {"Id":"UserMigrationBackgroundTimeout","Label":"[10.19]User migration background timeout","Impact":"If user migration exceeds the timeout, continue it in the background and show a notice page.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
